import ALink from '~/components/features/custom-link';
import { useProgramAccess } from './use-program-access';

// Accesos rápidos según el programa, renderizados en el sub-nav (header-bottom)
// donde estaban "Special Offers / Buy Riode", con la línea gráfica del template
// (icono + texto). La lógica de visibilidad vive en useProgramAccess (compartida
// con el MobileMenu).
function ProgramAccess() {
  const links = useProgramAccess();

  if (links.length === 0) return null;

  return (
    <>
      {links.map((link, i) => {
        const className = i === 0 ? '' : 'ml-4 ml-xl-6';
        const content = (
          <>
            <i className={link.icon}></i>
            {link.label}
          </>
        );

        if (link.onClick) {
          return (
            <ALink key={link.key} href="#" className={className} onClick={link.onClick}>
              {content}
            </ALink>
          );
        }

        if (link.external) {
          return (
            <a
              key={link.key}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className={className}
            >
              {content}
            </a>
          );
        }

        return (
          <ALink key={link.key} href={link.href!} className={className}>
            {content}
          </ALink>
        );
      })}
    </>
  );
}

export default ProgramAccess;
